export default __webpack_public_path__ + "static/bg-contact-71cecb8ae800543b3ab774678704ec2c.png";